import { Box } from '@bechtel/gds';
import { UnderConstruction } from '~/components';
import IssueComponents from './issue-components';
import OverridePrimaryStatus from './override-primary-status';
import RenameTags from './rename-tags';

export const navbarToolSectionItems = [
  {
    title: 'Analyze',
    path: 'analyze',
    parentPath: 'tools',
    default: true,
  },
  {
    title: 'Rename Tags',
    path: 'renametags',
    parentPath: 'tools',
    default: true,
  },
  {
    title: 'Override Primary Status',
    path: 'overrideprimarystatus',
    parentPath: 'tools',
    default: true,
  },
];

export const issueComponentsItem = [
  {
    title: 'Issue Components',
    path: 'issuecomponents',
    parentPath: 'tools',
    default: true,
  },
];

const UnderConstructionContainer = (
  <Box flexGrow={{ sm: ' 1' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
    <UnderConstruction />
  </Box>
);
export const toolsComponents = {
  analyze: UnderConstructionContainer,
  renametags: <RenameTags />,
  overrideprimarystatus: <OverridePrimaryStatus />,
  issuecomponents: <IssueComponents />,
};
